import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useQuery } from 'react-query';
import reportApi from '../../../api/report';

export default function useTestResult() {
  const { candidateId } = useParams();
  const [candidateResultId, setcandidateResultId] = useState<
    number | undefined
  >();
  const navigate = useNavigate();
  const { data } = useQuery(
    ['getScoreDetails', candidateResultId],
    () => reportApi.getScoreDetail(candidateResultId),
    {
      enabled: !!candidateId, // Only fetch when 'id' is available
    }
  );

  useEffect(() => {
    if (candidateId !== undefined) {
      const testId = +candidateId;
      setcandidateResultId(testId);
    } else {
      navigate('/report');
    }
  }, [candidateId]);

  return {
    data,
    candidateResultId,
  };
}
